// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");

var $ = require("./lib/qsa");
//var colors = require("./lib/colors");

//var matrix = $.one(".matrix");
//var key = $.one(".key");
//var detail = $.one(".detail");


